/** FAQ accordion — Figma homepage Questions frame (6280:60184). */

export const FAQ_FONT = "'Host Grotesk', sans-serif";

export const FAQ_COLOR = {
  title: '#1a1827',
  answer: '#434151',
  divider: '#eceef2',
  canvas: '#fbfbfd',
  icon: '#CF2048',
  section: '#F4F5F8',
  card: '#FFFFFF',
  cardBorder: '#E4E7EC',
};

/** Homepage preview length. The full set stays on /faqs and in FAQ schema. */
export const HOME_FAQ_PREVIEW_COUNT = 5;
